import 'bootstrap/dist/css/bootstrap.css'
import './index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from "react-router-dom"
import registerServiceWorker from './registerServiceWorker'
import App from './containers/App'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { runAuthentication } from "./settings/azure"
import theme from './settings/theme'
import ErrorBoundary from './components/ErrorBoundary '
import StoreProvider from './settings/context'

const rootElement = document.getElementById('root')

runAuthentication(() => {
  ReactDOM.render(
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <StoreProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </StoreProvider>
      </MuiThemeProvider>
    </BrowserRouter>,
    rootElement);

  registerServiceWorker()
}).catch(error => {
  console.error('Authentication error:', error)
})
